module.exports = __webpack_public_path__ + "img/Logo-31.321936b6.svg";